import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';
import type { HomeCuentaImagenesContent } from '../../models/home-cuenta-imagenes-content.model';
import { HomeCuentaImagenesService } from '../../services/home-cuenta-imagenes.service';
import {
  CUENTA_IMAGE_JURIDICA_FALLBACK,
  CUENTA_IMAGE_NATURAL_FALLBACK,
} from '../../utils/home-cuenta-imagenes-banner.mapper';
import { HomeCuentaFormJuridicaComponent } from './home-cuenta-form-juridica/home-cuenta-form-juridica.component';
import { HomeCuentaFormNaturalComponent } from './home-cuenta-form-natural/home-cuenta-form-natural.component';

export type HomeCuentaPerfil = 'natural' | 'juridica';

@Component({
  selector: 'app-home-cuenta',
  templateUrl: './home-cuenta.component.html',
  styleUrls: ['./home-cuenta.component.scss'],
  standalone: false,
})
export class HomeCuentaComponent implements OnInit {
  readonly anchorId = HOME_CONTENT_MOCK.anchors.creaCuenta;

  perfilSeleccionado: HomeCuentaPerfil = 'natural';
  /** PN tiene más campos: el panel crece siempre en ese perfil. */
  naturalExpanded = true;
  juridicaExpanded = false;

  @ViewChild(HomeCuentaFormNaturalComponent)
  private formNatural?: HomeCuentaFormNaturalComponent;

  @ViewChild(HomeCuentaFormJuridicaComponent)
  private formJuridica?: HomeCuentaFormJuridicaComponent;

  /** Sincronizado desde el hero (tarea 2.6 / 6.11). */
  @Input() set perfilInicial(perfil: HomeCuentaPerfil) {
    this.setPerfil(perfil);
  }

  /** Mantiene alineado `heroPersonaType` cuando el usuario cambia tabs en fase 6. */
  @Output() perfilChange = new EventEmitter<HomeCuentaPerfil>();

  imagenes: HomeCuentaImagenesContent = {
    naturalSrc: CUENTA_IMAGE_NATURAL_FALLBACK,
    juridicaSrc: CUENTA_IMAGE_JURIDICA_FALLBACK,
  };

  readonly icons = {
    face: 'assets/img/Home/cuenta/icon-face.svg',
    store: 'assets/img/Home/cuenta/icon-store.svg',
  } as const;

  constructor(private readonly homeCuentaImagenesService: HomeCuentaImagenesService) {}

  ngOnInit(): void {
    this.homeCuentaImagenesService.loadContent().subscribe((content) => {
      this.imagenes = content;
    });
  }

  setPerfil(perfil: HomeCuentaPerfil): void {
    if (perfil === this.perfilSeleccionado) {
      // Reaplicar expansion/estado visual aunque ya estuviera seleccionado (deep-link).
      this.naturalExpanded = perfil === 'natural';
      if (perfil === 'natural') {
        this.juridicaExpanded = false;
      }
      return;
    }

    this.perfilSeleccionado = perfil;
    this.perfilChange.emit(perfil);
    this.naturalExpanded = perfil === 'natural';
    this.juridicaExpanded = false;

    // Al cambiar de tab: ocultar errores sin borrar valores diligenciados.
    queueMicrotask(() => {
      this.formNatural?.clearValidationState();
      this.formJuridica?.clearValidationState();
    });
  }

  onNaturalVisibleErrors(_hasErrors: boolean): void {
    this.naturalExpanded = this.perfilSeleccionado === 'natural';
  }

  onJuridicaVisibleErrors(hasErrors: boolean): void {
    this.juridicaExpanded = this.perfilSeleccionado === 'juridica' && hasErrors;
  }

  isNatural(): boolean {
    return this.perfilSeleccionado === 'natural';
  }
}
